// @flow

/* eslint-disable react/jsx-key */

import React, {PureComponent} from 'react'
import {KonstellasjonSvg} from './svg/index'
import {H} from '../../shared/H/index'

import type {Enkeltmandat} from '../../../domain/result'

import {
  blokk as cnBlokk,
  blokk__separator as cnSeparator,
  blokk__line as line,
  blokk__content as content,
  blokk__toppline as toppline,
  blokk__bottomline as bottomline
} from './index.css'

export type BlokkParti = {
  kortNavn: string,
  antallMandater: number
}

export type Blokk = {
  id: string,
  statsministerkandidat: {
    navn: {
      fullt: string
    }
  },
  statsministerkandidatBilde: string,
  // statsministerkandidatBilde: {
  //   id: string,
  //   crops: {
  //     '54': string,
  //     '108': string
  //   }
  // },
  lederParti: string,
  partier: Array<BlokkParti>,
  totaltAntallMandater: number
}

type BlokkComponentProps = {
  blokk: Blokk,
  headingLevel: number
}

function toEnkeltmandater(partier: Array<BlokkParti>): Array<Enkeltmandat> {
  return partier
    .map(({antallMandater, kortNavn}) => {
      return [...new Array(antallMandater)].map(() => ({
        kortNavn,
        sortering: 0
      }))
    })
    .reduce((arr, next) => [...arr, ...next], [])
}

function kommaliste(list: Array<string>) {
  return list.map((item, index) => {
    let separator
    if (index === list.length - 1) {
      separator = ''
    } else if (index === list.length - 2) {
      separator = ' og '
    } else {
      separator = ', '
    }
    return [
      <span>
        {item}
      </span>,
      <span className={cnSeparator}>
        {separator}
      </span>
    ]
  })
}

export class BlokkComponent extends PureComponent {
  props: BlokkComponentProps

  render() {
    const {blokk, headingLevel} = this.props
    const bilde = blokk.statsministerkandidatBilde
    const mandater = toEnkeltmandater(blokk.partier)

    return (
      <div className={cnBlokk}>
        <div className={content}>
          <KonstellasjonSvg mandater={mandater} />
          <H level={headingLevel}>
            <span role="text">
              {kommaliste(blokk.partier.map(parti => parti.kortNavn))}
            </span>
          </H>
          <p>
            {blokk.totaltAntallMandater} mandater
          </p>
          <div className={line} />
          {mandater.length > 84 &&
            <div>
              <div className={toppline} />
              <div className={bottomline} />
            </div>}
        </div>
        <img src={bilde} width="54" height="54" aria-hidden="true" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/enblokksvisning/Blokk/index.js